import React from 'react';
import svgPaths from './svgPaths';

/**
 * FacilitiesIcon Component
 *
 * Icon representing facilities and locations
 */
const FacilitiesIcon = () => {
  return (
    <div className="relative size-full min-w-0 min-h-0" data-name="Facilities icon">
      <svg
        className="block size-full object-contain"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 154.716 160.524"
      >
          <g id="Facilities icon">
            <path
              d={svgPaths.p1709c100}
              fill="var(--fill-0, #2A4490)"
              id="Vector 8"
              stroke="var(--stroke-0, black)"
              strokeWidth="0.5"
            />
            <g id="Subtract">
              <mask fill="white" id="path-2-inside-1_10_1183">
                <path d={svgPaths.p370f4800} />
              </mask>
              <path d={svgPaths.p370f4800} fill="var(--fill-0, #B0DBF3)" />
              <path
                d={svgPaths.p368e0980}
                fill="var(--stroke-0, black)"
                mask="url(#path-2-inside-1_10_1183)"
              />
            </g>
            <path
              d={svgPaths.p2c118130}
              fill="var(--fill-0, #2A4490)"
              id="Vector 9"
              stroke="var(--stroke-0, black)"
              strokeWidth="0.5"
            />
            <g id="Key">
              <path
                d={svgPaths.p30287d00}
                fill="var(--fill-0, #B0DBF3)"
                id="Vector 10"
                stroke="var(--stroke-0, black)"
                strokeWidth="0.5"
              />
              <path
                d={svgPaths.p1b7322f0}
                fill="var(--fill-0, white)"
                id="Vector 11"
                stroke="var(--stroke-0, black)"
                strokeWidth="0.5"
              />
              <g id="Subtract_2">
                <mask fill="white" id="path-7-inside-2_10_1183">
                  <path d={svgPaths.p2c68a200} />
                </mask>
                <path d={svgPaths.p2c68a200} fill="var(--fill-0, white)" />
                <path
                  d={svgPaths.p1c8b1100}
                  fill="var(--stroke-0, black)"
                  mask="url(#path-7-inside-2_10_1183)"
                />
              </g>
              <path
                d={svgPaths.pad84c00}
                fill="var(--fill-0, white)"
                id="Vector 17"
                stroke="var(--stroke-0, white)"
                strokeWidth="0.5"
              />
              <path
                d="M88.8497 49L87.3497 48"
                id="Vector 15"
                stroke="var(--stroke-0, white)"
                strokeWidth="0.5"
              />
              <path d={svgPaths.pac46a80} fill="var(--fill-0, #B0DBF3)" id="Vector 12" />
              <path
                d={svgPaths.p3b397d00}
                fill="var(--fill-0, #B0DBF3)"
                id="Vector 13"
                stroke="var(--stroke-0, black)"
                strokeWidth="0.5"
              />
              <path
                d={svgPaths.p6118500}
                fill="var(--fill-0, #B0DBF3)"
                id="Vector 14"
                stroke="var(--stroke-0, black)"
                strokeWidth="0.5"
              />
              <path
                d="M82.4951 62.4861L80.3497 62"
                id="Vector 16"
                stroke="var(--stroke-0, white)"
                strokeWidth="0.5"
              />
            </g>
            <path d={svgPaths.p1765a480} fill="var(--fill-0, black)" id="Subtract_3" />
          </g>
        </svg>
    </div>
  );
};

export default FacilitiesIcon;
